import React from "react";

const ECGMEDIA = () => {
    return (
        <a href="https://ecgmedia.org/" target="_blank" rel="noopener noreferrer" className="poweredby-container">
            {/* <a href="https://ecgmedia.org" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#2c2c2c", padding: ".6rem", margin: "0" }}>
                powered by <span style={{ fontWeight: "700" }}>ECG</span>{" "}
                <span style={{ fontWeight: "500" }}>MEDIA</span>
            </a> */}
            <img className="poweredby-image" src="/poweredby.png" alt="" />
        </a>
    );
};

export default ECGMEDIA;
